var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLeaderboardStepsModal = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 344.85 84.54",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.8,66.83V41.63h-.24c0-.42,0-.85,0-1.28.05-2.47-.94-4.49-3.4-4.49H283.35a4.4,4.4,0,0,1-4.4-4.4V23.72a4.4,4.4,0,0,0-4.4-4.4H237.22a4.4,4.4,0,0,1-4.4-4.4V4.4a4.4,4.4,0,0,0-4.4-4.4h-103A4.4,4.4,0,0,0,121,4.4v9.69a4.4,4.4,0,0,1-4.4,4.4H58.66a4.4,4.4,0,0,0-4.4,4.4v8.57a4.4,4.4,0,0,1-4.4,4.4H4.64a4.4,4.4,0,0,0-4.4,4.49v1.28H0V84.54H344.8V79C344.88,74.91,344.86,70.87,344.8,66.83Z",
    fill: "#fec711"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeaderboardStepsModal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Leaderboard_StepsModal.ef528018.svg";
export { ForwardRef as ReactComponent };